import React from "react";
import clsx from "clsx";

import { SCORE_LABELS_JSX } from "../../constants/assessment-content";
import { X_LABELS_JSX } from "../../constants/assessment-content";
import { getListGradientColor } from "../../libs/Util";
import { DistributionType } from "../../templates/teacher/AllAssessmentDistribution";

import styles from "./BarChartAssesmentDistribution.module.scss";

export interface IAssessmentDistributionScore {
  type: DistributionType;
  distributions: {
    student: number[][];
  };
}

export type Props = {
  dataChart: IAssessmentDistributionScore[];
};

const COLORS: string[] = [
  "93FF89",
  "EA7F7F",
  "FFFFA5",
  "9FFFE5",
  "D9C06B",
  "C7C7C7",
  "629EFF",
];

const LIST_GRADIENT_COLORS: string[][] = COLORS.map(color =>
  getListGradientColor("FFFFFF", color, 8, 0.125),
);

const BarChartAssessmentDistribution: React.FC<Props> = ({ dataChart }) => {
  const dataDistribution = React.useMemo(() => {
    return dataChart.map(dataset => ({
      type: dataset.type,
      distributions: dataset.distributions.student,
    }));
  }, [dataChart]);

  const getWidthCol = (numCol: number) => {
    switch (numCol) {
      case 1:
        return "40%";
      case 2:
        return "30%";
      case 3:
        return "20%";
      case 4:
        return "15%";
      default:
        return "40%";
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapperChart}>
        <div className={styles.barChartWrapper}>
          {Array.from(Array(7).keys()).map(key => (
            <div className={styles.barChart} key={`barChart_${key}`}>
              <div className={styles.barChartContainer}>
                {dataDistribution.map((distribution, idx) => (
                  <div
                    key={`col_${idx}`}
                    className={clsx(
                      styles.col,
                      distribution.type === DistributionType.past &&
                        styles.past,
                    )}
                    style={{
                      width: getWidthCol(dataDistribution.length),
                    }}
                  >
                    {!!distribution.distributions.length &&
                      distribution.distributions[key].map((d, i) => (
                        <div
                          key={`dataset_${i}`}
                          className={styles.dataset}
                          style={{
                            flexGrow: d,
                            backgroundColor: `#${LIST_GRADIENT_COLORS[key][i]}`,
                          }}
                        />
                      ))}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className={styles.switch}>
          {X_LABELS_JSX.map((label, index: number) => (
            <div key={index} className={styles.switch__item}>
              <div>
                <p>{index + 1}</p>
                <span>{label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.yAxies}>
        <p>{SCORE_LABELS_JSX.label8}</p>
        <p>{SCORE_LABELS_JSX.label7}</p>
        <p>{SCORE_LABELS_JSX.label6}</p>
        <p>{SCORE_LABELS_JSX.label5}</p>
        <p>{SCORE_LABELS_JSX.label4}</p>
        <p>{SCORE_LABELS_JSX.label3}</p>
        <p>{SCORE_LABELS_JSX.label2}</p>
        <p>{SCORE_LABELS_JSX.label1}</p>
      </div>
    </div>
  );
};

export default BarChartAssessmentDistribution;
